import { Skeleton } from '@mantine/core';
import type { Filter } from '@repo/api-codegen';
import { EntityType } from '@repo/common/enums/entityType';
import { Suspense } from 'react';
import type { CatalogServerType } from '../../../components/CatalogView/types';
import { ErrorBoundary } from '../../../components/ErrorBoundary';
import { CatalogTable } from '../../TeamCatalogPage/CatalogTable';
import { useColumns } from '../../TeamCatalogPage/TeamCatalogPage.hooks';

interface IProfileTableProps {
	filters: { operands: Filter[] };
}

function ProfileTable({ filters }: IProfileTableProps) {
	const columns = useColumns();

	return (
		<ErrorBoundary>
			<Suspense fallback={<Skeleton h="70vh" w="100%" />}>
				<CatalogTable
					columns={columns.filter(
						(column) =>
							!['integration', 'parent', 'external_usage'].includes(
								column.accessor
							)
					)}
					columnVisibility={{
						catalogType: EntityType.all,
						catalogServerType: 'secoda_entity' as CatalogServerType,
					}}
					defaultRequiredSearchParams={{
						grab_all_entity_types: true,
					}}
					defaultRequiredCatalogFilters={filters}
				/>
			</Suspense>
		</ErrorBoundary>
	);
}

export default ProfileTable;
